import {
  __objRest,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/spinner/spinner.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var Spinner = forwardRef(
  (_a, ref) => {
    var _b = _a, { size = "medium", title = "", delay = false, className, style: _style } = _b, rest = __objRest(_b, ["size", "title", "delay", "className", "style"]);
    const style = __spreadValues(__spreadValues({}, _style), typeof delay === "string" && { "--hds-spinner-delay": delay });
    return /* @__PURE__ */ jsx(
      "div",
      __spreadValues({
        title,
        style,
        className: clsx(
          "hds-spinner",
          `hds-spinner--${size}`,
          delay && "hds-spinner--delay",
          className
        ),
        ref
      }, rest)
    );
  }
);
Spinner.displayName = "Spinner";

export {
  Spinner
};
//# sourceMappingURL=chunk-ZTZAPNZB.mjs.map